import {
  processUnitSetLabelAction,
  processUnitSetValueAction,
  processSetUnitsAction
} from '@r/reducers/utils';
import { inches, quantity } from 'decl/general/units';
import { AllActions } from '@r/storeUtils';
import { UnitsInputValue } from '@npmrost/storybook/stories/Vesta/Inputs/UnitsInput';

type tall =
  redux._IStore['calculationMode']['settings']['dimensions']['cabinets']['tall'];

const tallDefault: tall = {
  height: {
    value: 84 as inches,
    label: '84' as UnitsInputValue
  },
  depth: {
    value: 26 as inches,
    label: '26' as UnitsInputValue
  },
  shelvesQty: 4 as quantity
};

export const tall = (
  state = tallDefault,
  action: AllActions
): typeof state => {
  switch( action.type ) {
    case 'SET_CALCULATION_MODE_TALL_CABINET_HEIGHT_LABEL': {
      return {
        ...state,
        height: processUnitSetLabelAction( state.height, action )
      };
    }
    case 'SET_CALCULATION_MODE_TALL_CABINET_HEIGHT_VALUE': {
      return {
        ...state,
        height: processUnitSetValueAction( state.height, action )
      };
    }
    case 'SET_CALCULATION_MODE_TALL_CABINET_DEPTH_LABEL': {
      return {
        ...state,
        depth: processUnitSetLabelAction( state.depth, action )
      };
    }
    case 'SET_CALCULATION_MODE_TALL_CABINET_DEPTH_VALUE': {
      return {
        ...state,
        depth: processUnitSetValueAction( state.depth, action )
      };
    }
    case 'SET_CALCULATION_MODE_TALL_CABINET_SHELVES_QTY': {
      return {
        ...state,
        shelvesQty: action.value
      };
    }
    case 'SET_CALCULATION_MODE_UNITS': {
      return {
        ...state,
        height: processSetUnitsAction( state.height, action ),
        depth: processSetUnitsAction( state.depth, action )
      };
    }
    default:
      return state;
  }
};
